/**
 *
 */
export enum InternetFacilityUsage {
  Available = 1,
  NotAvailable = 2,
  AdditionalCharge = 3,
  Unimportant = 4,
}
